export default __webpack_public_path__ + "static/media/NE.773e42fa.svg";